import React from 'react'
import clsx from 'clsx'
import { Warning2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Banner from '../../atoms/Banner'

import useStyles from './styles'

const SINGULAR = 'is not available for Live Chat'
const PLURAL = 'are not available for Live Chat'
const MESSAGE =
  'They will not be able to see any chat messages sent until they are'

const OfflineAlertBanner = ({ names = [], className, message }) => {
  const theme = useTheme()

  const [usernames, setUsernames] = React.useState('')

  const classes = useStyles()

  React.useEffect(() => {
    if (names.length === 1) {
      setUsernames(`${names}`)
    } else if (names.length === 2) {
      setUsernames(`${names[0]} and ${names[1]}`)
    } else {
      let moreThanThree = names.join(', ')
      const idx = moreThanThree.lastIndexOf(',')

      setUsernames(
        moreThanThree.substr(0, idx) + ' and' + moreThanThree.substr(idx + 1)
      )
    }
  }, [names])

  return (
    <Banner className={clsx(classes.root, className)}>
      <div style={{ display: 'flex' }}>
        <Warning2 size={theme.size.base} className='icon' />

        <div className={classes.namesRoot}>
          <span style={{ fontWeight: theme.bold.bold }}>{usernames}</span>{' '}
          {!message ? (names.length === 1 ? SINGULAR : PLURAL) : message}
        </div>
      </div>

      <div>{!message && <em>{MESSAGE}</em>}</div>
    </Banner>
  )
}

export default OfflineAlertBanner
